import { render, staticRenderFns } from "./MemberTable.vue?vue&type=template&id=5d80dda4&"
import script from "./MemberTable.vue?vue&type=script&lang=js&"
export * from "./MemberTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports